export const ArrowBackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#fff">
      <path d="M384-123.69 27.69-480 384-836.31l39.54 39.54L106.77-480l316.77 316.77L384-123.69Z" />
    </svg>
  )
}
